<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <p class="mb-3">{{ $t("registerPage.selection-poste-fonction") }}</p>

    <PosteDetails :user="innerUser" @change-poste="changePoste"></PosteDetails>

    <div class="buttons">
      <b-button type="is-dark" @click="goBack">
        {{ $t("registerPage.precedent") }}
      </b-button>
      <b-button type="is-primary" @click="handleSubmit(submit)">
        {{ $t("registerPage.inscription") }}
      </b-button>
    </div>
  </ValidationObserver>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import { UtilisateurRegistrationDTO } from "@/model/bean/GeneratedDTOs"
import PosteDetails from "@/views/commons/PosteDetails.vue"
import { BButton } from "buefy"

export default defineComponent({
  name: "FonctionInformationsView",
  components: {
    ValidationObserver,
    PosteDetails,
    BButton,
  },

  props: {
    modelValue: {
      type: Object as () => UtilisateurRegistrationDTO,
      required: true,
    },
  },

  emits: ["update:model-value", "go-back"],
  data() {
    return {
      innerUser: new UtilisateurRegistrationDTO(),
    }
  },
  created(): void {
    this.innerUser = { ...this.modelValue }
  },
  methods: {
    changePoste(changedUser: UtilisateurRegistrationDTO): void {
      this.innerUser.fonction = changedUser.fonction
      this.innerUser.employeur = changedUser.employeur
      this.innerUser.grae = changedUser.grae
    },

    submit(): void {
      this.$emit("update:model-value", this.innerUser)
    },

    goBack(): void {
      this.$emit("go-back", this.innerUser)
    },
  },
})
</script>
<style scoped lang="scss">
.buttons {
  justify-content: space-between;
}
</style>
